import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 8.5c1.1 0 2-.4 2.8-1.2S16 5.6 16 4.5s-.4-2-1.2-2.8S13.1.5 12 .5s-2 .4-2.8 1.2S8 3.4 8 4.5s.4 2 1.2 2.8 1.7 1.2 2.8 1.2m-1.4-5.4c.4-.4.9-.6 1.4-.6s1 .2 1.4.6.6.9.6 1.4-.2 1-.6 1.4-.9.6-1.4.6-1-.2-1.4-.6S10 5 10 4.5s.2-1 .6-1.4m9 8.5c-.3-.5-.7-.8-1.2-1.1-1-.5-2.1-.9-3.2-1.2-1-.2-2.1-.3-3.2-.3s-2.2.1-3.2.4c-1.1.2-2.2.6-3.2 1.1-.5.2-.9.6-1.2 1.1s-.4 1-.4 1.6v8.3c0 .5.2 1 .6 1.4s.9.6 1.4.6h12c.5 0 1-.2 1.4-.6s.6-.9.6-1.4v-8.3c0-.6-.1-1.1-.4-1.6M18 21.5H6v-8.3c0-.2 0-.4.1-.5.1-.2.2-.3.4-.4.9-.4 1.8-.8 2.7-1S11 11 12 11s1.9.1 2.8.3 1.8.6 2.7 1c.2.1.3.2.4.4.1.1.1.3.1.5z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M13.8 15.4h-.7v-.7c0-.3-.1-.5-.3-.7s-.4-.3-.7-.3-.5.1-.7.3-.3.4-.3.7v.7h-.7c-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7.4.3.7.3h.6v.7c0 .3.1.5.3.7s.4.3.7.3.5-.1.7-.3.3-.4.3-.7v-.7h.7c.3 0 .5-.1.7-.3s.3-.4.3-.7-.1-.5-.3-.7q-.15-.3-.6-.3" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }